<template>
  <v-app id="leerdoelen">
    <v-navigation-drawer
        class="grey lighten-2"
        v-model="drawer"
        fixed
        app
    >
      <v-list>
        <v-list-tile to="/">
          <v-list-tile-content>
            <v-list-tile-title>Startpagina</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>



        <v-list-tile to="search">
          <v-list-tile-content>
            <v-list-tile-title>Leerdoelen zoeken</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to="wat-je-moet-weten">
          <v-list-tile-content>
            <v-list-tile-title>Wat je moet weten</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to="verantwoording">
          <v-list-tile-content>
            <v-list-tile-title>Verantwoording</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to="feedback">
          <v-list-tile-content>
            <v-list-tile-title>Feedback</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to="over-cedin">
          <v-list-tile-content>
            <v-list-tile-title>Over Cedin</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>



      <br>

      <v-btn outline small class='mt-5' @click="refresh">
        refresh
      </v-btn>

      <v-btn
          color="white"
          class="black--text"
          fab
          @click="drawer=false"
          bottom
          style="position:absolute; right: 10px; bottom: 15px;"
      >
        <v-icon>close</v-icon>
      </v-btn>

    </v-navigation-drawer>

    <v-toolbar color="primary" dark fixed app>
      <v-toolbar-side-icon class="hidden-sm-and-down" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Leerdoelen</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-btn
          fixed
          dark
          fab
          bottom
          right
          color="accent"
          class="hidden-md-and-up"
      >
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-btn>

      <v-container fluid fill-height style="outline:2px solid red">
        <v-layout
        >
          <v-flex xs-12>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer color="primary" app>
      <small class="white--text ml-1">&copy; Cedin {{ (new Date()).getFullYear() }}</small>
    </v-footer>
  </v-app>
</template>

<script>


export default {
  name: 'leerdoelen-app',
  components: {
  },
  methods: {
    refresh: function () {
      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name);
        }
        window.location.reload(true);
      });
    },
  },
  data() {
    return {
      drawer: null,
    }
  }
}
</script>
